export const joinClassNames = (...classNames: (string | boolean | undefined)[]) =>
  classNames.filter(Boolean).join(' ');
